/**
 * Shortcut for `Object.entries()` static method.
 * @param  {Record<string, any>} obj a target object
 * @returns {[string, any][]}
 */
const ObjectEntries = (obj) => Object.entries(obj);
export default ObjectEntries;
